import { Injectable } from '@angular/core';
import { CryptoService } from '@core/services/crypto.service';
import { throwError } from 'rxjs';
import packageJson from 'package.json';

@Injectable({
  providedIn: 'root'
})
export class StorageService {

  private _name: string = packageJson.name + '_enc';

  private _sessionMap: Map<string, any> = new Map<string, any>();

  private setMap(key: string, data: any): void {
    this._sessionMap.set(key, data);

    sessionStorage.setItem(this._name, this._CryptoService.aesEncrypt([...this._sessionMap]));

  }

  private getMap(key?: string): any {
    if (!key && this._sessionMap.size > 0) {
    }
    return this._sessionMap.get(key as string) || console.warn(`Key "${key}" not found in the session map`);
  }

  private removeMap(key?: string) {
    if (!key && this._sessionMap.size == 0) {
      return;
    }
    if (!key && this._sessionMap.size > 0) {
      this._sessionMap.clear();
      sessionStorage.removeItem(this._name);
      return;
    }
    this._sessionMap.delete(key as string) || console.warn(`Key "${key}" not found in the session map`);

    if (this._sessionMap.size > 0) {
      sessionStorage.setItem(this._name, this._CryptoService.aesEncrypt([...this._sessionMap]));
    }
  }

  hasKey(key: string): boolean {
    if (this._sessionMap.has(key)) {
      return true
    }
    throwError(() => 'The key does not exist in the storage');
    return false;
  }

  constructor(
    private _CryptoService: CryptoService
  ) {
    if (sessionStorage.getItem(this._name)) {
      this._sessionMap = new Map<string, any>(JSON.parse(this._CryptoService.aesDecrypt(sessionStorage.getItem(this._name) as string)));

    }
  }

  setItem(key: string, data: any) {
    // if (typeof data === 'object') {
    //   data = JSON.stringify(data);
    // }
    this.setMap(key, data);
    // sessionStorage.setItem(key, this._CryptoService.aesEncrypt(data))
  }

  getItem(key?: string) {
    return this.getMap(key);
    // if (this.hasKey(key)) {
    //   return JSON.parse(this._CryptoService.aesDecrypt(sessionStorage.getItem(key)))
    // }
    // return false;
  }

  removeItem(key?: string) {
    this.removeMap(key);
    // if (this.hasKey(key)) {
    //   sessionStorage.removeItem(key);
    //   return
    // }

  }
}
